<div class="custom-toast-message-box" [ngClass]="{'show': show}">
    <div class="custom-toast-message-box-inner" 
         [ngClass]="{
           'custom-toast-message-box-inner-success': type === 'success',
           'custom-toast-message-box-inner-error': type === 'error',
            'custom-toast-message-box-inner-warning': type === 'warning',
            'custom-toast-message-box-inner-info': type === 'info',
         }">
        <button class="custom-toast-message-box-inner-close-btn" (click)="close()"></button>
        <div class="custom-toast-message-box-inner-icon"></div>
        <div class="custom-toast-message-box-inner-content">
            <h4>{{ title }}</h4>
            <p>{{ message }}</p>
        </div>
    </div>
</div>
